import Navbar from "../components/Navbar"
import AskCarebuddy from "../components/AskCarebuddy";
import languageContext from "../context/language/languageContext";
import { useContext, useEffect, useState } from "react";    
const Booking = ()=>{
    console.log("Booking")
    const { Carebuddy,setCarebuddy } = useContext(languageContext);
    useEffect(()=>{
        setCarebuddy("Book a Care Buddy")
    }, [])
    return(
        <>
        <Navbar/>
        <div className="w-full overflow-y-auto"> {/* Make this section scrollable */}
                    < AskCarebuddy Carebuddy={Carebuddy} setCarebuddy={setCarebuddy}/>
                </div>

        </>
    )
}
export default Booking